import React from 'react'
import styles from './demo_button.module.css'

const href = 'https://www.wagetap.com/?action=demo'

export default ({ label }) => (
  <a href={href} className={styles.ctaButton}>
    {label || 'Book a demo'}
  </a>
)
